module.exports = __webpack_public_path__ + "static/media/3-sposoby-na-zmotywowanie-dziecka-do-nauki.6f9cc5e7.png";